import { cn } from '../../lib/cn';
import { Card } from './Card';

interface ListPageLayoutProps {
  /** Barre de filtres / recherche / action, rendue en haut de la carte. */
  header?: React.ReactNode;
  /** Contenu principal : tableau, grille, liste. */
  children: React.ReactNode;
  /** Active le scroll horizontal interne pour le contenu large. */
  scrollable?: boolean;
  className?: string;
  /** Classes du bloc sous l’en-tête. `min-w-0` laisse un tableau large défiler dans la carte. */
  bodyClassName?: string;
}

/**
 * Layout standard des pages liste/détail : conteneur centré (.main-container-gdm)
 * + Card à bords arrondis. Restaure le rendu carte de référence (Dashboard).
 */
export function ListPageLayout({
  header,
  children,
  scrollable,
  className,
  bodyClassName,
}: ListPageLayoutProps) {
  return (
    <div className="main-container-gdm">
      <Card flush header={header} className={className}>
        <div className={cn(scrollable && 'overflow-x-auto', bodyClassName)}>{children}</div>
      </Card>
    </div>
  );
}
